import { Link } from '@inertiajs/react'
import { ArrowLeft, CreditCard, XCircle } from 'lucide-react'
import CheckoutLayout from '@/frontend/layouts/CheckoutLayout'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

interface Props {
  worker?: {
    id: string
    name: string
  } | null
}

export default function CheckoutCancel({ worker }: Props) {
  const retryHref = worker
    ? `/dashboard/digital_workers/new?worker_id=${worker.id}&onboarding_step=subscription`
    : '/dashboard/digital_workers/new'

  return (
    <CheckoutLayout>
      <div className="min-h-screen flex items-center justify-center px-4 py-28">
        <div className="w-full max-w-xl text-center">
          <div className="mb-6 flex justify-center">
            <XCircle className="h-16 w-16 text-rose-300" />
          </div>

          <h1 className="text-3xl font-bold text-white">Checkout cancelado</h1>
          <p className="mt-3 text-base text-slate-300">
            {worker
              ? `A assinatura de ${worker.name} continua pendente e nenhuma cobrança foi concluída.`
              : 'Nenhuma cobrança foi concluída.'}
          </p>

          <Card className="mt-8 border-slate-700 bg-slate-900/70">
            <CardContent className="p-5 text-sm text-slate-300">
              A criação do colaborador fica salva. Você pode retomar a assinatura quando estiver pronto.
            </CardContent>
          </Card>

          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Button
              asChild
              size="lg"
              className="bg-gradient-to-r from-indigo-500 to-violet-500 text-white shadow-lg shadow-violet-900/40 transition-all hover:from-indigo-400 hover:to-violet-400"
            >
              <Link href={retryHref}>
                <CreditCard className="h-4 w-4" />
                Retomar assinatura
              </Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-white/15 bg-transparent text-slate-200 transition-all hover:bg-white/10 hover:text-white"
            >
              <Link href="/dashboard">
                <ArrowLeft className="h-4 w-4" />
                Voltar ao início
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </CheckoutLayout>
  )
}
